import {
  Application,
  AuthorisedUser,
  CrudEventEnum,
  LoginStatus,
  OktaUserStatus,
  TradingLimitType,
  User,
  UserDetail,
  UserStatus
} from 'api'
import { Translation } from 'locale'

export const SYSTEM_USER_NAME = 'SYSTEM'

export function getUserInitials(user: User): string {
  return `${user.firstName[0]}${user.lastName[0]}`
}

export function getUserFullName(user: User): string {
  return `${user.firstName} ${user.lastName}`
}

export function newEmptyUserDetailForAdd(): UserDetail {
  const user: User = {
    id: '',
    username: '',
    organisationId: '',
    firstName: '',
    lastName: '',
    status: UserStatus.SUSPENDED,
    phoneNumber: null,
    algoName: null,
    notes: null,
    canTrade: false,
    shortId: null,
    tradingEntityDetails: [],
    allTradingEntities: false,
    productRights: [],
    loginStatus: LoginStatus.NOT_LOGGED_IN,
    featureToggle: {},
    oktaDetailsLastUpdated: new Date(),
    oktaLastLogin: new Date(),
    oktaUserStatus: OktaUserStatus.ACTIVE,
    lastLoggedOutInstant: null,
    lastLogoutReason: null,
    rateLimiterLogoutInstants: [],
    tradingControlLimit: {
      tradingLimitType: TradingLimitType.NONE,
      limitsByCurrency: {}
    },
    lastGroups: []
  }

  return {
    user,
    organisation: null,
    availableEvents: [CrudEventEnum.UPSERT]
  }
}

export const userStatusTranslationMap = {
  [UserStatus.ACTIVE]: Translation.TC_ENABLED,
  [UserStatus.SUSPENDED]: Translation.TC_DISABLED,
  [UserStatus.DELETED]: Translation.TC_DELETED
}

export const userStatusTranslationReverseMap = {
  [Translation.TC_ENABLED]: UserStatus.ACTIVE,
  [Translation.TC_DISABLED]: UserStatus.SUSPENDED,
  [Translation.TC_DELETED]: UserStatus.DELETED
}

export const isAdmin = (user: AuthorisedUser) => user.application === Application.ADMIN_GATEWAY
